/**
 * 페이지별 SEO 메타 데이터
 * 검색엔진이 각 페이지를 고유하게 인식하도록 title, description, keywords 설정
 */

const SEO_META = {
  // 메인
  home: {
    title: "법대리 | 전세금 반환, 내용증명, 지급명령 법률 서비스",
    description:
      "전세금 못 받았을 때, 내용증명부터 임차권등기명령, 지급명령까지. 법대리에서 전문 변호사가 3분 만에 해결해드립니다. 합리적 비용의 법률 대행 서비스.",
    keywords:
      "전세금 반환, 내용증명, 임차권등기명령, 지급명령, 보증금 반환, 법률 서비스, 변호사",
    url: "https://by-law.kr/",
  },

  // 임차인 - 전세금 반환
  estate: {
    title: "전세금 반환 | 내용증명·임차권등기명령 대행 - 법대리",
    description:
      "전세보증금을 돌려받지 못하고 계신가요? 법대리에서 내용증명 발송부터 임차권등기명령, 보증금 반환 소송까지 전문 변호사가 대행합니다.",
    keywords:
      "전세금 반환, 전세보증금, 내용증명, 임차권등기명령, 보증금 반환 소송, 전세금 못받을때",
    url: "https://by-law.kr/services/estate",
  },

  // 임차인 - 전체 서비스
  estateAll: {
    title: "임차인 법률 서비스 전체 | 전세금 반환·보증금 보호 - 법대리",
    description:
      "임차인을 위한 법률 서비스. 전세금 반환 내용증명, 임차권등기명령, 가압류, 지급명령, 보증금 반환 소송까지 한 곳에서 해결하세요.",
    keywords:
      "임차인 법률, 전세금 반환, 보증금 보호, 임차권등기, 전세 소송",
    url: "https://by-law.kr/services/estate_all",
  },

  // 임대인 - 명도소송
  estateHost: {
    title: "명도소송 | 세입자 퇴거·월세미납 대응 - 법대리",
    description:
      "세입자가 안 나가거나 월세를 안 낼 때, 내용증명부터 명도소송, 강제집행까지 전문 변호사가 대행합니다. 집주인을 위한 법률 서비스.",
    keywords:
      "명도소송, 세입자 퇴거, 월세미납, 강제집행, 집주인 법률, 임대인 소송",
    url: "https://by-law.kr/services/estateHost",
  },

  // 명도소송 전용
  vacatehouse: {
    title: "명도소송 절차·비용·기간 | 집주인 전문 법률 서비스 - 법대리",
    description:
      "명도소송 절차가 궁금하신가요? 소송 비용, 기간, 강제집행까지 전문 변호사가 안내합니다. 월세미납, 무단점유, 계약만료 세입자 퇴거.",
    keywords:
      "명도소송, 명도소송 절차, 명도소송 비용, 명도소송 기간, 세입자 퇴거, 강제집행",
    url: "https://by-law.kr/services/vacatehouse",
  },

  // 지급명령
  pay: {
    title: "지급명령 신청 | 빌려준 돈·임금체불·보증금 반환 - 법대리",
    description:
      "빌려준 돈, 매매대금, 용역대금, 임금, 보증금 등 못 받는 돈을 지급명령으로 빠르게 해결. 일반 소송의 10% 비용으로 2~4주 만에 법원 판결.",
    keywords:
      "지급명령, 지급명령 신청, 빌려준 돈, 임금체불, 보증금 반환, 채권추심",
    url: "https://by-law.kr/services/pay",
  },

  // 임차인 보호 (임차권등기)
  housingProtect: {
    title: "임차권등기명령 신청 대행 | 이사 후 보증금 보호 - 법대리",
    description:
      "보증금을 못 받고 이사해야 할 때, 임차권등기명령으로 대항력과 우선변제권을 유지하세요. 법대리에서 신청을 대행합니다.",
    keywords:
      "임차권등기명령, 임차권등기명령 신청, 임차권등기 비용, 보증금 보호, 이사 보증금",
    url: "https://by-law.kr/services/housing_protect",
  },

  // 형사 - 음주운전
  criminal: {
    title: "형사 변호 | 음주운전·마약·성범죄 전문 변호사 - 법대리",
    description:
      "형사 사건 전문 변호사 매칭. 음주운전, 마약, 성범죄 등 각 분야 경험 많은 변호사가 사건을 검토하고 최선의 결과를 만들어드립니다.",
    keywords: "형사 변호사, 음주운전 변호사, 마약 변호사, 성범죄 변호사, 형사 사건",
    url: "https://by-law.kr/services/criminal",
  },

  // 고소장
  accusation: {
    title: "고소장 작성 대행 | 전문 변호사가 직접 작성 - 법대리",
    description:
      "고소장 작성이 어려우신가요? 전문 변호사가 사건을 분석하고 법적 요건에 맞는 고소장을 작성해드립니다.",
    keywords: "고소장, 고소장 작성, 고소장 대행, 고소 방법, 형사 고소",
    url: "https://by-law.kr/services/accusation",
  },

  // 대여금 (빌려준 돈)
  loan: {
    title: "빌려준 돈 돌려받기 | 지급명령·내용증명 - 법대리",
    description:
      "빌려준 돈을 돌려받지 못하고 계신가요? 내용증명 발송부터 지급명령 신청까지, 가장 빠르고 저렴한 방법으로 해결해드립니다.",
    keywords:
      "빌려준 돈, 돈 안갚을때, 채권추심, 지급명령, 대여금 반환, 내용증명",
    url: "https://by-law.kr/services/loan",
  },

  // 소음
  noise: {
    title: "층간소음 법률 서비스 | 내용증명·손해배상 - 법대리",
    description:
      "층간소음으로 고통받고 계신가요? 내용증명 발송부터 손해배상 청구까지 전문 변호사가 대행합니다.",
    keywords: "층간소음, 층간소음 내용증명, 층간소음 법적대응, 소음 손해배상",
    url: "https://by-law.kr/services/noise",
  },

  // 성범죄
  sexual: {
    title: "성범죄 변호 | 전문 변호사 매칭 - 법대리",
    description:
      "성범죄 사건 전문 변호사를 매칭해드립니다. 신속하고 비밀이 보장되는 상담을 받아보세요.",
    keywords: "성범죄 변호사, 성범죄 상담, 성폭력 변호사",
    url: "https://by-law.kr/services/sexual",
  },

  // 상속
  inherit: {
    title: "상속 포기·한정승인 | 전문 변호사 대행 - 법대리",
    description:
      "상속 포기, 한정승인 신청을 전문 변호사가 대행합니다. 빚 상속 걱정 없이 합리적 비용으로 해결하세요.",
    keywords: "상속 포기, 한정승인, 상속 빚, 상속 변호사, 상속 포기 신청",
    url: "https://by-law.kr/services/inherit",
  },

  // 온라인 사기
  onlineScam: {
    title: "온라인 사기 피해 | 고소·환불 법률 서비스 - 법대리",
    description:
      "인터넷 쇼핑 사기, 중고거래 사기 피해를 당하셨나요? 고소장 작성부터 피해 구제까지 전문 변호사가 도와드립니다.",
    keywords: "온라인 사기, 인터넷 사기, 중고거래 사기, 사기 고소, 환불",
    url: "https://by-law.kr/services/online_scam",
  },

  // 서비스 소개
  introduction: {
    title: "법대리 서비스 소개 | 쉽고 간편한 법률 서비스",
    description:
      "법대리는 과잉 진료 걱정 없이, 합리적 비용으로 전문 변호사가 1:1로 사건을 해결해드리는 법률 서비스입니다.",
    keywords: "법대리, 법률 서비스, 변호사 매칭, 법률 상담",
    url: "https://by-law.kr/introduction",
  },

  // 이용방법
  howToUse: {
    title: "법대리 이용방법 | 3분 만에 법률 서비스 신청",
    description:
      "법대리 이용방법을 안내합니다. 신청서 작성 3분, 변호사 검토 후 무료 안내 연락을 드립니다.",
    keywords: "법대리 이용방법, 법률 서비스 신청, 변호사 상담",
    url: "https://by-law.kr/howToUse",
  },

  // 생활법률
  livingLaw: {
    title: "생활법률 정보 | 알아두면 좋은 법률 상식 - 법대리",
    description:
      "일상에서 꼭 알아야 할 법률 상식과 정보를 쉽게 알려드립니다. 전세, 임대차, 소송 관련 생활법률.",
    keywords: "생활법률, 법률 상식, 임대차 법률, 전세 법률",
    url: "https://by-law.kr/livingLaw",
  },
};

export default SEO_META;
